import { apiClient } from "./apiClient"
import { encryptField } from "../utils/encryption"
// import { OTPError } from "./../utils/validation/OTPErrors";


class RegisterService{
   async checkExistingUser (userData){
    console.log('Checking existing user...');    
    try {
        const [emailResponse, mobileResponse] = await Promise.all([
        apiClient.post('/api/register/check-email',{
            // email: encryptField(userData.email)
            email: userData.email
        }),
        apiClient.post('/api/register/check-mobile',{
            // mobile: encryptField(userData.mobile)
            mobile: userData.mobile
        })
    ]);
    if(emailResponse.data && emailResponse.data.exists){
        console.log('Email Already Registerd ==> frontend');        
        throw new Error('Email Already Registerd')
    }   
    if(mobileResponse.data && mobileResponse.data.exists){
        console.log('Mobile Already Registerd '); 
        throw new Error('Mobile already Registerd')
    }
    return true
    } catch (error) {
        if(error.reeponse?.status === 408 || !navigator.onLine){
        console.error("Check internet connection")
    }else{ 
        console.error("Checking existing user", error)
        throw error
    }
    }   
   }  

  async sendOTP (mobile){
    const otp = Math.floor(1000 + Math.random() * 9000);
    // console.log("Generated OTP==>", otp);    
    try {
           const reeponse = await apiClient.post('/api/send-sms', {                
                mobile: encryptField(mobile),
                otp: encryptField(otp.toString()) // ✅ Encrypt OTP for security
                // otp: otp.toString()
            });           
            console.log('✅ OTP sent successfully');
            return otp;
            
        } catch (error) {            
            console.error('❌ Failed to send OTP:', error);
            if(error.reeponse?.status=== 400){
                throw new Error('Invalid mobile number.')
            }
            throw new Error('Failed to send OTP. Please try again.');
        }

  }

  

  async submitRegistration(formData) {
    const formDataObject = new FormData();

    // append encryption
    formDataObject.append('email', encryptField(formData.email));
    formDataObject.append('mobile', encryptField(formData.mobile));
    formDataObject.append('otp', encryptField(formData.otp));

    // append without encryption fields (will be hashed in backend);
    formDataObject.append('fullname', formData.fullname);
    formDataObject.append('password', formData.password);
    formDataObject.append('cnfpassword', formData.cnfpassword);
    formDataObject.append('dob', formData.dob);
    formDataObject.append('gender', formData.gender);
    formDataObject.append('grade', formData.grade);
    formDataObject.append('board', formData.board);
    formDataObject.append('tmc', formData.tmc.toString());

    const response = await apiClient.post('/api/register', formDataObject);
    return response.data
    
  } 

  async sendConfirmationEmail (email, fullname){
    try {
        const response = apiClient.post('/api/send-email',{
        email,
        fullname
    })
    // if(!response.ok){
    //     console.error("Failed to send email", error)
    // }
    } catch (error) {
        console.error("Failed to send OTP", error)
        throw new Error("Failed to send OTP")
    }
    
  }
   
   


}
export const registerService = new RegisterService() 